import { Component, OnInit, ViewChild } from '@angular/core';
import { CircularRequestComponent } from 'src/app/front-user/services/Circulars/circular-request/circular-request.component';
import { Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
//import { RebateRequestRequestorDecisionComponent } from 'src/app/front-user/services/long-haul/rebate-request-requestor-decision/rebate-request-requestor-decision.component';
import { CircularRequestRequestorDecisionComponent } from 'src/app/front-user/services/Circulars/Circular-request-requestor-decision/Circular-request-requestor-decision.component';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-circular-request-request-details',
  templateUrl: './circular-request-request-details.component.html'
})
export class CircularRequestDetailsComponent implements OnInit {
  //#region Properties & Variables
  //Request Properties
  private RequestId: string = "";
  @ViewChild('circularRequest',{static: false}) circularRequest: CircularRequestComponent;
  @ViewChild('rebateRequestRequestorDecision',{static: false}) rebateRequestRequestorDecision: CircularRequestRequestorDecisionComponent;

  public currentUser: User = new User();
  //#endregion

  constructor(private router: Router, private globalServices: GlobalServices, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({behavior:'smooth'});
  }
  onRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.RequestId = this.circularRequest.rebateRequestLoaded.Id;
      this.circularRequest.showOptionDev = false;
      this.circularRequest.editModeAdmin = true;
    }
  }
  onRebateRequestRequestorDecisionLoadedFlag(flag: boolean) {
    if(flag){}
  }
  navigateToAccurateDataForm(): void {
    this.router.navigate(['RebateRequest/AccurateDataForm'], { state: { data: { requestId: this.RequestId } } });
  }
  navigateToConfirmShipPassing(): void {
    this.router.navigate(['RebateRequest/ConfirmShipPassing'], { state: { data: { requestId: this.RequestId } } });
  }
  navigateToReleaseRebate(): void {
    this.router.navigate(['RebateRequest/ReleaseRebate'], { state: { data: { requestId: this.RequestId } } });
  }
  navigateToMarkRequestAsRefunded(): void {
    this.router.navigate(['RebateRequest/Refunded'], { state: { data: { requestId: this.RequestId } } });
  }
  navigateToCloneRequest(): void {
    this.router.navigate(['CircularRequest/CloneRequest'], { state: { data: { requestId: this.RequestId } } });
  }
}
